import UiKitButton from 'components/ui-kit/Button/Button';
import { useTranslation } from 'react-i18next';

type Props = {
  rating: number;
  onNext: () => void;
};

const RateActions = ({ rating, onNext }: Props) => {
  const { t } = useTranslation();

  return (
    <UiKitButton buttonType="primary" fullWidth disabled={rating === 0} onClick={onNext}>
      {t('components.feedback.next')}
    </UiKitButton>
  );
};

export default RateActions;
